// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13 0H12V2H13C16.866 2 20 5.13401 20 9V10H22V9C22 4.02944 17.9706 0 13 0Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 2H4V24H20V12H18V18H6V4H10V2ZM13.0039 20V22.0039H11V20H13.0039Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 4H12V6H13C14.6569 6 16 7.34315 16 9V10H18V9C18 6.23858 15.7614 4 13 4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14.0039 8H12V10.0039H14.0039V8Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-hotspot-wave-filled')
export default class HotspotWaveFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hotspot-wave-filled',
    }
  }
}
